import { useState } from "react";

//상품 수량
export default function CountInput(data){
    const [count,setCount] = useState(data.val ? data.val : 0);

    function setCountUp(){
        if(data.qty && (data.optionQty ? Math.min(Number(data.optionQty),Number(data.qty)) : data.qty) < (data.maxQty||data.optionMaxQty ? Number(Math.min(data.maxQty||9999,data.optionMaxQty||9999)) : 9999)){
            if(data.val < (data.optionQty ? Math.min(Number(data.optionQty),Number(data.qty)) : data.qty)){
                data.func(countVal(data.val) + 1);
            }else if(data.excessFunc){
                data.excessFunc()
            }
        }else{
            if(data.val < (data.maxQty||data.optionMaxQty ? Number(Math.min(data.maxQty||9999,data.optionMaxQty||9999)) : 9999)){
                data.func(countVal(data.val) + 1);
            }else if(data.excessFunc){
                window.errMsg("최대 수량입니다.");
                data.excessFunc()
            }
        }
    }

    function setCountDown(){
        if(data.val > 0){
            data.func(countVal(data.val) - 1);
        }else{
            if(data.delType){
                data.delFunc();
            }else{
                data.func(0);
            }
        }
    }

    function countVal(e){
        let value = e;

        return value ? value : 0;
    }

    return (
        <div className={`countBox ${data.addClass||""}`}>
            <button type="button" onClick={() => setCountDown()} className="btn_m"><img src={`/assets/images/icon/${data.val > 0 ? "ms_on" : "ms_off"}.svg`}/></button>
            <input type="text" value={countVal(data.val)} readOnly className="countInput"/>
            <button type="button" onClick={() => setCountUp()} className="btn_p"><img src={`/assets/images/icon/${data.val < 9999 && (data.qty||data.optionQty ? data.val < (data.optionQty ? Math.min(Number(data.optionQty),Number(data.qty)) : data.qty) : data.maxQty||data.optionMaxQty ? data.val < Number(Math.min(data.maxQty||9999,data.optionMaxQty||9999)) : true) ? "plus_on" : "plus_off"}.svg`}/></button>
        </div>
    );
}